import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  IParseCreatorsCsvRequest,
  IParseCreatorsGoogleSheetRequest,
} from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";

export function useParseCreatorsCsv(
  handleSuccess?: (data: IParseCreatorsGoogleSheetRequest[]) => void
) {
  const {
    mutate: parseCreatorsCsv,
    isLoading: isParsingCreatorsCsv,
    isSuccess: isParsedCreatorsCsv,
    data,
  } = useMutation<
    IParseCreatorsCsvRequest,
    BackednResponse<IParseCreatorsGoogleSheetRequest[]>
  >({
    mutationFn: (payload) =>
      BriefService.parseCreatorsCsv(payload).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (_c, response) => {
      handleSuccess?.(response.data);
    },
  });

  return {
    parseCreatorsCsv,
    isParsingCreatorsCsv,
    isParsedCreatorsCsv,
    parsedRows: data?.data ?? [],
  };
}
